module.exports = __webpack_public_path__ + "static/BadNinjaDX-7b28208e7c4f682c51fede99f45840c6.png";